/* eslint-disable no-unused-vars,prefer-destructuring */
import { IModel } from '@src/js/separate-logic/interface/IModel';
import RenderTaskGroup from '@src/slide/infrastructure/module/dependent/taskManager/renderTaskGroup';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';

export default class SlideComponentModel implements IModel {
    public isFirstRender: boolean;
    public taskGroup: any;

    public initModel(props: any) {
        this.isFirstRender = true;
        const { slideModel } = props;
        if (props.index > 0 && !slideModel.isPlaceHolder && !slideModel.isTemp) {
            this.taskGroup = new RenderTaskGroup(
                `render-children-slide-${slideModel.key}`,
                TaskPriority.HIGH,
            );
        }
    }
}
